module.exports = __webpack_public_path__ + "fonts/IstokWeb-Regular.eb5ea075.eot";